import { httpClient } from '../../../net/httpClient';
import UrlConfig from '../../../net/UrlConfig';

import {
  ON_CPT_QUERY_INPUT_CHANGE,
  START_LOAD_CPT_INFO,
  LOAD_CPT_INFO_SUCCESS,
  LOAD_CPT_INFO_FAILURE,
  INIT_LOAD_CPT_INFO_ACTION_STATUS,
  SELECT_CPT_INFO,
  OPEN_ADD_OR_EDIT_CPT_MODAL,
  ADD_OR_EDIT_CPT_CHANGE_INPUT,
  START_ADD_OR_EDIT_CPT,
  ADD_OR_EDIT_CPT_SUCCESS,
  ADD_OR_EDIT_CPT_FAILURE,
  INIT_ADD_OR_EDIT_CPT_ACTION_STATUS,
  RESET_ADD_OR_EDIT_CPT_MODAL,
  OPEN_DEL_CPT_MODAL,
  START_DEL_CPT,
  DEL_CPT_SUCCESS,
  DEL_CPT_FAILURE,
  INIT_DEL_CPT_ACTION_STATUS,
  RESET_DEL_CPT_MODAL,
  START_SUBMIT_CPT,
  SUBMIT_CPT_SUCCESS,
  SUBMIT_CPT_FAILURE,
  INIT_SUBMIT_CPT_ACTION_STATUS,
} from './CptConstants';

export function onCptQueryInputChange({ name, value }) {
  return {
    type: ON_CPT_QUERY_INPUT_CHANGE,
    payload: { name, value },
  };
}

function startLoadCptInfo() {
  return {
    type: START_LOAD_CPT_INFO,
  };
}

export function loadCptInfo(params) {
  return function(dispatch) {
    dispatch(startLoadCptInfo());
    httpClient
      .get(UrlConfig.QUERY_CPT_LIST, params)
      .then(resp => dispatch(loadCptInfoSuccess(resp)))
      .catch(err => dispatch(loadCptInfoFailure(err)));
  };
}

function loadCptInfoSuccess(resp) {
  return {
    type: LOAD_CPT_INFO_SUCCESS,
    payload: resp,
  };
}

function loadCptInfoFailure(err) {
  return {
    type: LOAD_CPT_INFO_FAILURE,
    payload: err,
  };
}

export function initLoadCptInfoActionStatus() {
  return {
    type: INIT_LOAD_CPT_INFO_ACTION_STATUS,
  };
}

export function selectCptInfo(array) {
  return {
    type: SELECT_CPT_INFO,
    payload: array,
  };
}

export function openAddOrEditCptModal(mode, data) {
  return {
    type: OPEN_ADD_OR_EDIT_CPT_MODAL,
    payload: { mode, data },
  };
}

export function addOrEditCptChangeInput({ name, value }) {
  return {
    type: ADD_OR_EDIT_CPT_CHANGE_INPUT,
    payload: { name, value },
  };
}

function startAddOrEditCpt() {
  return {
    type: START_ADD_OR_EDIT_CPT,
  };
}

export function addOrEditCpt(params) {
  return function(dispatch) {
    dispatch(startAddOrEditCpt());
    httpClient
      .post(UrlConfig.ADD_OR_EDIT_CPT, params)
      .then(resp => dispatch(addOrEditCptSuccess(resp)))
      .catch(err => dispatch(addOrEditCptFailure(err)));
  };
}

function addOrEditCptSuccess(resp) {
  return {
    type: ADD_OR_EDIT_CPT_SUCCESS,
    payload: resp,
  };
}

function addOrEditCptFailure(err) {
  return {
    type: ADD_OR_EDIT_CPT_FAILURE,
    payload: err,
  };
}

export function initAddOrEditCptActionStatus() {
  return {
    type: INIT_ADD_OR_EDIT_CPT_ACTION_STATUS,
  };
}

export function resetAddOrEditCptModal() {
  return {
    type: RESET_ADD_OR_EDIT_CPT_MODAL,
  };
}

export function openDelCptModal(data) {
  return {
    type: OPEN_DEL_CPT_MODAL,
    payload: data,
  };
}

function startDelCpt() {
  return {
    type: START_DEL_CPT,
  };
}

export function delCpt(params) {
  return function(dispatch) {
    dispatch(startDelCpt());
    httpClient
      .post(UrlConfig.DELETE_CPT, params)
      .then(resp => dispatch(delCptSuccess(resp)))
      .catch(err => dispatch(delCptFailure(err)));
  };
}

function delCptSuccess(resp) {
  return {
    type: DEL_CPT_SUCCESS,
    payload: resp,
  };
}

function delCptFailure(err) {
  return {
    type: DEL_CPT_FAILURE,
    payload: err,
  };
}

export function initDelCptActionStatus() {
  return {
    type: INIT_DEL_CPT_ACTION_STATUS,
  };
}

export function resetDelCptModal() {
  return {
    type: RESET_DEL_CPT_MODAL,
  };
}

function startSubmitCpt() {
  return {
    type: START_SUBMIT_CPT,
  };
}

export function submitCpt(params) {
  return function(dispatch) {
    dispatch(startSubmitCpt());
    httpClient
      .post(UrlConfig.ADD_OR_EDIT_CPT, params)
      .then(resp => dispatch(submitCptSuccess(resp)))
      .catch(err => dispatch(submitCptFailure(err)));
  };
}

function submitCptSuccess(resp) {
  return {
    type: SUBMIT_CPT_SUCCESS,
    payload: resp,
  };
}

function submitCptFailure(err) {
  return {
    type: SUBMIT_CPT_FAILURE,
    payload: err,
  };
}

export function initSubmitCptActionStatus() {
  return {
    type: INIT_SUBMIT_CPT_ACTION_STATUS,
  };
}
